import { render, staticRenderFns } from "./UIMultiSelect.vue?vue&type=template&id=9c9042d8&scoped=true"
import script from "./UIMultiSelect.vue?vue&type=script&lang=js"
export * from "./UIMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./UIMultiSelect.vue?vue&type=style&index=0&id=9c9042d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9042d8",
  null
  
)

export default component.exports